export default __webpack_public_path__ + "static/media/hidragloss.afd702d5.png";